import React from "react";
import { FaTimes } from "react-icons/fa";

const SlidingDiv = ({ isOpen, onClose, title, children, className }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      {/* Overlay */}
      <div
        className="flex-1 bg-black/40"
        onClick={onClose}
      />

      {/* Sliding Panel */}
      <div className={`bg-white h-full w-full sm:w-3/4 lg:w-3/4 xl:w-3/4 shadow-2xl flex flex-col ${className}`}>
        {/* Header */}
        <div className="flex items-center justify-between p-3 border-b border-gray-200 bg-white sticky top-0 z-10">
          <h3 className="font-semibold text-sm md:text-lg text-gray-800 truncate">{title}</h3>
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center h-8 w-8 rounded-full bg-red-50 text-red-600 hover:bg-red-100 transition-colors"
          >
            <FaTimes size={14} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-3 md:p-4" id="form">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SlidingDiv;
